const WEEKDAY_PLURAL = ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays'];

export function timezoneAbbrevFromLabel(label) {
  const s = String(label || '');
  if (s.includes('/')) {
    try {
      const formatted = new Intl.DateTimeFormat('en-US', {
        timeZone: s,
        timeZoneName: 'short'
      }).format(new Date());
      const abbr = formatted.split(' ').pop();
      if (abbr) return abbr.toUpperCase();
    } catch {
      // Fallback to mappings below.
    }
  }
  if (s.includes('Pacific')) return 'PT';
  if (s.includes('Mountain')) return 'MT';
  if (s.includes('Central') && !s.includes('European')) return 'CT';
  if (s.includes('Eastern')) return 'ET';
  if (s.includes('北京') || s.toLowerCase().includes('beijing') || s.includes('Shanghai')) return 'CST';
  if (s.includes('European') || s.includes('CET')) return 'CET';
  return 'ET';
}

/** e.g. "Tuesdays at 4:00 PM" — typicalTime uses JS getDay() (0 = Sunday). */
export function formatPrimaryWeeklyLine(typicalTime) {
  if (!typicalTime || typicalTime.dayOfWeek == null) return null;
  const day = WEEKDAY_PLURAL[typicalTime.dayOfWeek];
  if (!day) return null;
  const h = typicalTime.hours24;
  const m = typicalTime.minutes || 0;
  const period = h >= 12 ? 'PM' : 'AM';
  let h12 = h % 12;
  if (h12 === 0) h12 = 12;
  const timePart = m === 0 ? `${h12}:00 ${period}` : `${h12}:${String(m).padStart(2, '0')} ${period}`;
  return `${day} at ${timePart}`;
}

/** 25% of sessions, rounded up (minimum 1 when n >= 1). */
export function maxReschedulesAllowed(lessonCount) {
  const n = Math.max(0, lessonCount);
  if (n === 0) return 0;
  return Math.ceil(n * 0.25);
}
